import React, { HTMLAttributes, useEffect, useRef, useState } from 'react';
import { MDSTable, TableBodyProps, TableRowProps } from '@marqvision/mds-v2';

type TbodyProps = TableBodyProps & {
  as: 'tbody';
};

type TrProps = TableRowProps & {
  as: 'tr';
};

type DivProps = React.PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    as?: 'div';
  }
>;

export type Props = {
  className?: string;
  initHeight?: number;
  isDisabled?: boolean;
  minWidth?: string | number;
} & (TrProps | DivProps | TbodyProps);

export const VirtualizationWrapper = (props: Props) => {
  const { as, children, initHeight = 0, minWidth, style, ...restProps } = props;

  const [isOnScreen, setIsOnScreen] = useState(false);
  const [height, setHeight] = useState<string | number>('auto');

  const listWrapperRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries.at(-1);
      if (!entry) return;
      setIsOnScreen(entry.isIntersecting);
      const height = entry.isIntersecting ? 'auto' : entry.target.clientHeight;
      setHeight(height);
    });
    if (listWrapperRef.current) {
      observer.observe(listWrapperRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  if (as === 'tbody' || as === 'tr') {
    const TableComponent = as === 'tbody' ? MDSTable.Body : MDSTable.Row;

    return (
      <TableComponent
        ref={listWrapperRef}
        style={{ height: typeof height === 'string' ? `${initHeight}px` : `${height}px`, ...style }}
        {...(restProps as any)} //TODO-@morgan: 컴포넌트에 따른 타입 구분 필요
      >
        {isOnScreen ? (children as React.ReactElement) : <></>}
      </TableComponent>
    );
  }

  return (
    <div
      ref={listWrapperRef}
      style={{
        minHeight: typeof height === 'string' ? initHeight : Math.min(initHeight, height),
        height: typeof height === 'string' ? height : `${height}px`,
        ...(minWidth !== undefined
          ? {
              minWidth,
            }
          : {}),
        ...style,
      }}
      {...restProps}
    >
      {isOnScreen ? children : <></>}
    </div>
  );
};
